import { render } from "./PageH.vue?vue&type=template&id=385045a9&scoped=true"
import script from "./PageH.vue?vue&type=script&lang=js"
export * from "./PageH.vue?vue&type=script&lang=js"

import "./PageH.vue?vue&type=style&index=0&id=385045a9&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385045a9"]])

export default __exports__